<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

import AgencyFocus from '@/components/AgencyFocus/AgencyFocus.vue';
import DirectoryLocationSearch from '@/components/DirectoryLocationSearch/DirectoryLocationSearch.vue';
import DirectorySearchPlane from '@/components/DirectorySearchPlane/DirectorySearchPlane.vue';
import { useAgencyProfilesStore } from '@/stores/agencyProfiles';

const agencyProfilesStore = useAgencyProfilesStore();
const { selectedListingType } = storeToRefs(agencyProfilesStore);

const locationSearchRef = ref<InstanceType<typeof DirectoryLocationSearch> | null>(null);

watch(selectedListingType, () => {
  locationSearchRef.value?.applySearch();
});
</script>

<template>
  <div>
    <DirectorySearchPlane activeType="agency">
      <template #locations>
        <DirectoryLocationSearch
          ref="locationSearchRef"
          :store="agencyProfilesStore"
          :stripQueryKeys="['page', 'loc', 'includeChildren', 'listingType', 'sortBy']"
        />
      </template>
      <template #filters>
        <AgencyFocus />
      </template>
    </DirectorySearchPlane>
  </div>
</template>
